import React, { type ReactElement } from 'react';

import { discounted_upgrade_path } from '@routes';

import ClusterAccess from './Access';
import ClusterHeader from './Header';
import ClusterOfferings from './Offerings';
import ClusterQuote from './Quote';
import { ClusterParams } from './interfaces';

const ClusterLayout = ({
  dollarSavings,
  proOfferCode,
  sectionData,
}: Omit<ClusterParams, 'clusterID'>): ReactElement => {
  const upgradePath = discounted_upgrade_path({ offer: proOfferCode });

  return (
    <main className="mx-auto mb-90 max-w-[1040px] px-16 sm:px-28 lg:mb-112 lg:px-0 xl:max-w-container-lg">
      <ClusterHeader
        description={sectionData.description}
        dollarSavings={dollarSavings}
        proOfferCode={proOfferCode}
        upgradePath={upgradePath}
      />
      <ClusterAccess sectionData={sectionData} />
      <ClusterOfferings />
      <ClusterQuote proOfferCode={proOfferCode} upgradePath={upgradePath} />
    </main>
  );
};

export default ClusterLayout;
